import React from "react";
import { Bar, CartesianGrid, ComposedChart, Legend, Line, ResponsiveContainer, Tooltip, XAxis, YAxis } from "recharts";
import { ChartBar } from "@phosphor-icons/react";
import { Panel, bucketLabel, tooltipStyle } from "./dashUtils";

export function UsageChart({ data, loading }) {
  const hourly = data?.granularity === "hour";
  const rows = (data?.series || []).map((s) => ({ ...s, label: bucketLabel(s.bucket, hourly) }));
  const empty = !loading && data && data.totals.questions === 0 && data.totals.conversations === 0;
  return (
    <Panel title="Usage over time" testid="usage-analytics-chart" className="lg:col-span-2"
      aside={data && <span className="text-xs text-neutral-500" data-testid="usage-totals">{data.totals.questions} questions · {data.totals.conversations} chats</span>}>
      <div className="h-[280px]">
        {loading && !data ? (
          <div className="h-full rounded-lg bg-white/[0.02] animate-pulse" />
        ) : empty ? (
          <div className="h-full flex flex-col items-center justify-center gap-2 text-sm text-neutral-600" data-testid="usage-empty">
            <ChartBar size={28} weight="duotone" /> No customer activity in this range.
          </div>
        ) : (
          <ResponsiveContainer width="100%" height="100%">
            <ComposedChart data={rows} margin={{ top: 4, right: 8, left: -18, bottom: 0 }}>
              <CartesianGrid stroke="#1a1a1a" vertical={false} />
              <XAxis dataKey="label" tick={{ fill: "#737373", fontSize: 11 }} axisLine={{ stroke: "#262626" }} tickLine={false} minTickGap={18} />
              <YAxis allowDecimals={false} tick={{ fill: "#737373", fontSize: 11 }} axisLine={false} tickLine={false} />
              <Tooltip {...tooltipStyle} />
              <Legend wrapperStyle={{ fontSize: 12, color: "#a3a3a3", paddingTop: 8 }} iconType="circle" iconSize={8} />
              <Bar dataKey="text" name="Text questions" stackId="q" fill="#73bf44" radius={[0, 0, 0, 0]} maxBarSize={36} />
              <Bar dataKey="voice" name="Voice questions" stackId="q" fill="#38bdf8" radius={[3, 3, 0, 0]} maxBarSize={36} />
              <Line dataKey="conversations" name="New chats" type="monotone" stroke="#f5f5f5" strokeWidth={1.5} dot={false} strokeDasharray="4 3" />
            </ComposedChart>
          </ResponsiveContainer>
        )}
      </div>
    </Panel>
  );
}
